import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trending-topics-16MwJ",
  "use": "trending-topics-16MwJ-usage",
  "viewBox": "0 0 24 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 20\" id=\"trending-topics-16MwJ\"><path d=\"M18.195 3.5H14.5v-2h7v7h-2V5.056l-5.353 6.383-1.999-2.569-4.859 6.244-1.578-1.228 6.437-8.273 2.057 2.644 3.99-4.757zM4.5 17.5h17v2h-19V.5h2v17z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol